import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CryptoHelperServiceService {
  public encrypt<T>(data: T): string {
    const stringData = JSON.stringify(data);
    return btoa(stringData);
  }

  public decrypt<T>(encryptedData: string): T | null {
    const decodedString = atob(encryptedData);
    return JSON.parse(decodedString);
  }
}
